export type JourneyEventType =
  | 'email'
  | 'sms'
  | 'call'
  | 'chat'
  | 'opportunity_created'
  | 'opportunity_updated'
  | 'opportunity_committed'
  | 'opportunity_completed'
  | 'opportunity_withdrawn'
  | 'action_created'
  | 'action_updated'
  | 'action_completed'
  | 'action_blocked'
  | 'action_withdrawn'
  | 'outcome_detected'
  | 'escalation'
  | 'handoff'
  | 'financial_milestone'
  | 'system';

export type JourneyChannel = 'email' | 'sms' | 'phone' | 'chat' | 'system' | 'crm';
export type JourneySourceType = 'fa' | 'client' | 'aiAgent' | 'system';
export type JourneyDirection = 'inbound' | 'outbound';
export type JourneySeverity = 'info' | 'warn' | 'danger' | 'success';

export type JourneyQuickFilter =
  | 'all'
  | 'communications'
  | 'ai-handled'
  | 'escalations'
  | 'opportunity-lifecycle'
  | 'action-lifecycle';

export interface JourneyEvent {
  id: string;
  eventType: JourneyEventType;
  channel: JourneyChannel;
  title: string;
  summary: string;
  occurredAt: string;
  createdAt: string;
  updatedAt: string;
  sourceType: JourneySourceType;
  sourceName: string;
  direction?: JourneyDirection;
  tags: string[];
  severity?: JourneySeverity;
  linkedOpportunityIds: string[];
  linkedActionIds: string[];
  linkedOutcomeIds: string[];
  metadata: Record<string, unknown>;
  detailPayload: JourneyDetailPayload;
}

export interface JourneyDetailPayload {
  transcript?: string;
  actorChain?: string[];
  confidence?: number;
  goalAligned?: boolean;
  escalationReason?: string;
  linkedOpportunityTitles?: string[];
  linkedActionTitles?: string[];
  linkedOutcomeTitles?: string[];
  metricSnippet?: string;
  notes?: string;
}

export interface ClientJourneyState {
  events: JourneyEvent[];
}
